import React from "react";
import SEO from "../component/SEO.js";
import "./PetrolPumpSoftware.css";

const PetrolPumpSoftware = () => {
  return (
    <>
      <SEO
        title="Best Petrol Pump Software in India | Fuel Management System"
        description="BizPetro petrol pump software helps automate billing, inventory, and fuel management. Ideal for petrol pumps and fuel stations across India."
      />

      <div className="petrol-container">

        {/* HERO */}
        <section className="hero">
          <h1>Best Petrol Pump Management Software in India</h1>
          <p>
            BizPetro is an advanced fuel management software designed to automate
            petrol pump operations including billing, stock tracking, and real-time reporting.
          </p>

          <a
            href="https://bizpetro.com"
            target="_blank"
            rel="noreferrer"
            className="btn-primary"
          >
            View Live Demo
          </a>
        </section>

        {/* ABOUT */}
        <section className="section section-light">
          <h2>What is Petrol Pump Software?</h2>
          <p>
            Petrol pump software is a digital solution that helps fuel stations manage daily
            operations such as billing, fuel sales, stock tracking, and reporting.
            With BizPetro, petrol pump owners can automate processes, reduce manual errors,
            and gain real-time insights into their business performance.
          </p>
        </section>

        {/* FEATURES */}
        <section className="section section-light">
          <h2>Key Features of BizPetro Petrol Pump Software</h2>

          <div className="grid">
            <div className="card">Fuel Billing & Invoicing</div>
            <div className="card">Inventory & Tank Monitoring</div>
            <div className="card">Real-time Sales Reports</div>
            <div className="card">GST & Accounting Integration</div>
            <div className="card">Multi-Station Management</div>
            <div className="card">Automation & Remote Access</div>
          </div>
        </section>

        <section className="section section-light">
          <h2>Benefits of Petrol Pump Management Software</h2>

          <ul className="list">
            <li>Reduce fuel loss and pilferage</li>
            <li>Improve operational efficiency</li>
            <li>Real-time monitoring of fuel stock</li>
            <li>Accurate billing and reporting</li>
            <li>Better decision making with data insights</li>
          </ul>
        </section>

        <section className="section section-light">
          <h2>Why Choose BizPetro?</h2>
          <p>
            BizPetro is designed specifically for Indian fuel stations and petrol pumps.
            It offers a scalable and reliable system suitable for both single outlets
            and multi-location businesses. Our solution ensures smooth operations,
            better control, and increased profitability.
          </p>
        </section>

        {/* CTA */}
        <section className="cta">
          <h2>Ready to Automate Your Petrol Pump?</h2>
          <p>Start using smart fuel management today.</p>

          <a
            href="https://bizpetro.com"
            target="_blank"
            rel="noreferrer"
            className="btn-primary"
          >
            Explore BizPetro Software
          </a>
        </section>

      </div>
    </>
  );
};

export default PetrolPumpSoftware;